import {Component, inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {UserSessionService} from '../../services/user-session-service/user-session.service';
import {TitleService} from '../../services/title-service/title.service';
import {TranslatePipe} from '@ngx-translate/core';
import {ServiceProviderHub} from '@generated-backend-types';
import AuthenticatedContact = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Auth.AuthenticatedContact;

@Component({
  selector: 'app-account',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    TranslatePipe
  ],
  templateUrl: './account.component.html',
})
export class AccountComponent implements OnInit {
  private userSessionService = inject(UserSessionService);
  private titleService = inject(TitleService);
  private user?: AuthenticatedContact = this.userSessionService.user$.value;

  form = new FormGroup({
    first_name: new FormControl(this.user?.first_name ?? ''),
    last_name: new FormControl(this.user?.last_name ?? ''),
    email: new FormControl(this.user?.email ?? ''),
    phone: new FormControl(this.user?.phone_number ?? ''),
    company: new FormControl(this.user?.service_provider?.company ?? ''),
    street: new FormControl(this.user?.service_provider?.street ?? ''),
    street_number: new FormControl(this.user?.service_provider?.street_number ?? ''),
    zip_code: new FormControl(this.user?.service_provider?.zip_code ?? ''),
    city: new FormControl(this.user?.service_provider?.city ?? ''),
    country: new FormControl(this.user?.service_provider?.country ?? ''),
    url: new FormControl(this.user?.service_provider?.website ?? ''),
  });

  ngOnInit() {
    this.titleService.setTitle('authenticated.account.title');
    this.form.disable();
  }
}
